var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var Logger = /** @class */ (function () {
    function Logger(enabled, enabledLevels) {
        if (enabled === void 0) { enabled = false; }
        if (enabledLevels === void 0) { enabledLevels = []; }
        this.enabled = enabled;
        this.enabledLevels = new Set(enabledLevels);
    }
    Logger.init = function (config) {
        // Get or create instance
        var instance = Logger.getInstance();
        // Update configuration
        if (config.enabled !== undefined) {
            instance.setEnabled(config.enabled);
        }
        if (config.enabledLevels !== undefined) {
            instance.setEnabledLevels(config.enabledLevels);
        }
    };
    Logger.getInstance = function (config) {
        var _a, _b;
        if (!Logger.instance) {
            Logger.instance = new Logger((_a = config === null || config === void 0 ? void 0 : config.enabled) !== null && _a !== void 0 ? _a : false, (_b = config === null || config === void 0 ? void 0 : config.enabledLevels) !== null && _b !== void 0 ? _b : []);
        }
        return Logger.instance;
    };
    Logger.prototype.setEnabled = function (enabled) {
        this.enabled = enabled;
    };
    Logger.prototype.isLoggingEnabled = function () {
        return this.enabled;
    };
    Logger.prototype.setEnabledLevels = function (levels) {
        this.enabledLevels = new Set(levels);
    };
    Logger.prototype.getEnabledLevels = function () {
        return Array.from(this.enabledLevels);
    };
    Logger.prototype.shouldLog = function (level) {
        if (!this.enabled)
            return false;
        return this.enabledLevels.has(level);
    };
    Logger.prototype.formatMessage = function (message) {
        var timestamp = new Date().toLocaleString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
        });
        return "[Formo Analytics][".concat(timestamp, "] ").concat(message);
    };
    Logger.prototype.debug = function (message) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (this.shouldLog("debug")) {
            console.debug.apply(console, __spreadArray([this.formatMessage(message)], args, false));
        }
    };
    Logger.prototype.info = function (message) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (this.shouldLog("info")) {
            console.info.apply(console, __spreadArray([this.formatMessage(message)], args, false));
        }
    };
    Logger.prototype.warn = function (message) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (this.shouldLog("warn")) {
            console.warn.apply(console, __spreadArray([this.formatMessage(message)], args, false));
        }
    };
    Logger.prototype.error = function (message) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (this.shouldLog("error")) {
            console.error.apply(console, __spreadArray([this.formatMessage(message)], args, false));
        }
    };
    Logger.prototype.trace = function (message) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (this.shouldLog("trace")) {
            console.trace.apply(console, __spreadArray([this.formatMessage(message)], args, false));
        }
    };
    Logger.prototype.log = function (message) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        this.info.apply(this, __spreadArray([message], args, false));
    };
    return Logger;
}());
export { Logger };
// Export a default instance for easy use
export var logger = Logger.getInstance();
//# sourceMappingURL=Logger.js.map